module.exports = __webpack_public_path__ + "static/media/paris.2f64dd39.PNG";